<template>
  <div>
    <mdb-card>
      <mdb-card-body>
        <form @submit.prevent="save">
          <mdb-input
            v-model="checklist.name"
            label="Checklist Name"
            required
          />

          <!--<mdb-input
            v-model="checklist.pattern"
            label="Checklist Taskqueue Name Pattern (Optional)"
          />-->

          <h5 class="mt-4">Checklist Items</h5>
          <div v-for="(item, index) in checklist.items" :key="index" class="d-flex mb-2">
            <mdb-input
              v-model="item.text"
              label="Item Text"
              class="flex-grow-1 mr-2"
              required
            />
            <mdb-btn
              color="danger"
              size="sm"
              @click="removeItem(index)"
              class="align-self-center"
            >
              Remove
            </mdb-btn>
          </div>
          <mdb-btn
            color="primary"
            size="sm"
            @click="addItem"
            class="mb-3"
          >INT UNSIGNED
            Add Item
          </mdb-btn>
          <div>
            <div class="mb-4">
              <label>Client:</label>
              <select v-model="userId" label="Client" required class="browser-default custom-select">
              <option :key="`${i}`"  v-for="(item, i) in customerOptions" :value="item.value">{{ item.text }}</option>
            </select>
            </div>
            <div>
              <label>Project:</label>
              <mdb-select v-model="projectChoices" label="Projects" :multiple="true" :taggable="true" :visibleOptions="20" @getValue="handleSelection" />
            </div>
          </div>
          <mdb-btn
            type="submit"
            color="success"
            class="mr-2"
            v-if="userId && checklist.name && projectChoices.some((item) => item.value)"
          >
            Save Checklist
          </mdb-btn>
        </form>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import Apicall from '@/libs/Apicall';
import {
  mdbCard, mdbCardBody, mdbInput, mdbBtn, mdbSelect,
} from 'mdbvue';

export default {
  components: {
    mdbCard,
    mdbCardBody,
    mdbInput,
    mdbBtn,
    mdbSelect,
  },
  props: {
    initialChecklist: {
      type: Object,
      default: () => ({
        id: null,
        pattern: '',
        name: '',
        items: [],
        customer_id: null,
        user_id: null,
        project_id: null,
      }),
    },
  },
  computed: {
    customerOptions() {
      return [{
        text: 'None', value: null,
      }, ...this.customers.map((customer) => ({ value: customer.id, text: customer.email }))];
    },
    projectOptions() {
      return [{
        text: 'None', value: null,
      }, ...this.projects.map((project) => ({ value: project.projectid, text: project.name }))];
    },
  },
  mounted() {
    this.userId = this.initialChecklist?.user_id ?? null;
    this.projectId = this.initialChecklist?.project_id ?? null;

    this.getCustomers();
  },
  data() {
    return {
      checklist: { ...this.initialChecklist },
      customers: [],
      projects: [],
      projectChoices: [],
      userId: null,
      projectId: null,
    };
  },
  watch: {
    initialChecklist: {
      deep: true,
      handler(newVal, oldValue) {
        this.userId = newVal?.user_id ?? null;
        this.projectId = newVal?.project_id ?? null;
      },
    },
     userId(newVal) {
      console.log('New user ID', newVal);
      this.getCustomerProjects(newVal);
    },
    projectId(newVal) {
      console.log(newVal);
    },
  },
  methods: {
    addItem() {
      this.checklist.items.push({ text: '' });
    },
    removeItem(index) {
      this.checklist.items.splice(index, 1);
    },
    cancel() {
      this.$emit('cancel');
    },
    save(event) {
      event.preventDefault();
      const api = new Apicall();

      const projectIds = this.projectChoices.filter((p) => p.selected).map((p) => p.value);
      this.checklist.user_id = this.userId;

      api.call('POST', this.checklist?.id ? 'api/adminchecklist/edit' : 'api/adminchecklist/', {
        ...this.checklist, project_ids: projectIds,
      }).then((response) => {
        if (response.status === 'OK') {
          this.$emit('save', response.data);
        } else {
          this.$emit('error', response.msg);
        }
      });
    },
    getCustomerProjects(customerId) {
      const api = new Apicall();

      api.call('GET', `api/project/get-all-projects-by-customer-id?customerid=${customerId}`).then((response) => {
        if (response.status === 'OK') {
          this.projects = response.data.projectinfos;
          this.projectChoices = response.data.projectinfos.map((element) => {
            const found = this.checklist.projects?.find((p) => p.projectid === element.projectid) ?? false;
            console.log('Project ID', element.projectid, found);
            let result = null;
            if (found) {
              result = { value: element.projectid, text: element.name, selected: true };
            } else {
              result = { value: element.projectid, text: element.name, selected: false };
            }
            return result;
          });
        } else {
          this.$emit('error', response.msg);
        }
      });
    },
    handleSelection(values) {
      console.log('Values', values);
    },
    getCustomers() {
      const api = new Apicall();

      api.call('GET', 'api/admincustomer/list').then((response) => {
        if (response.status === 'OK') {
          this.customers = response.data;
        } else {
          this.$emit('error', response.msg);
        }
      });
    },
  },
};
</script>
